import { ISubjectsToSetValFormat } from './types'

/** Подготавливает массив предметов для преобразования их в квери строку */
export const subjectsToSetValFormat: ISubjectsToSetValFormat = (subjects) => {
  return subjects.map(
    (subject) => ({
      set: subject.id,
      val: 100,
    }),
    []
  )
}
